.root {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 16px;
  text-align: center;
}

.spinner-slot {
  align-items: center;
  color: var(--color-primary);
  display: flex;
  height: 40px;
  justify-content: center;
  margin-bottom: 4px;
}

.progress-track {
  background: var(--color-surface-subtle, var(--color-border));
  border-radius: 999px;
  height: 6px;
  margin-top: 12px;
  overflow: hidden;
  width: 100%;
}

.progress-fill {
  background: var(--color-primary);
  height: 100%;
  transition: width 200ms ease-out;
}
